import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { Hint } from '../hint/hint.tsx';
import { HelpCircleIcon } from '../icons/react/help-circle.tsx';
import { noDataContainer } from './no-data.css.ts';

interface NoDataProps extends ComponentPropsWithRef<'div'> {
  hintContent?: string;
}

export const NoData = ({
  ref,
  className,
  children,
  hintContent,
  ...rest
}: NoDataProps) => (
  <div ref={ref} className={clsx(noDataContainer, className)} {...rest}>
    {children || 'No data available yet.'}
    {hintContent ? (
      <Hint description={hintContent}>
        <HelpCircleIcon />
      </Hint>
    ) : null}
  </div>
);
